module.exports = __webpack_public_path__ + "public/img/通行记录Bg.115a4101.png";